// extracted by mini-css-extract-plugin
module.exports = {"speedmeter":"speedmeter_speedmeter__ye8El","speedmeter__needle":"speedmeter_speedmeter__needle__yv0r2"};